<template>
  <div id="container">

    <!-- 타이틀  -->
    <div class="title_wrap">
      <div class="title_wrap">
        <h1>메뉴관리
          <button @click="registMenu" class="mid_btn orange"><i class="write_icon"></i>
            <span>메뉴등록</span>
          </button>
        </h1>
      </div>
    </div>
    <!-- //타이틀  -->

    <!-- 검색 영역 -->
    <div class="contents_wrap">
      <div class="content_list">

        <div class="filter_wrap" id="filter_section">
          <ul class="filter_list">
            <li>
              <dd>
                <label>상세검색 </label>
                <ul class="twos">
                  <li>
                    <kendo-dropdownlist
                      ref="searchCdRef"
                      id="searchCdText"
                      :data-source="searchTextData"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdNameSpace'"
                      :index="0"
                      v-bind:style="'width: 100%;'"
                      @change="commonOnChangeEvent"
                    >
                    </kendo-dropdownlist>
                  </li>
                  <li>
                    <kendo-maskedtextbox
                      ref="searchTextRef"
                      id="searchText"
                      v-bind:style="'width: 100%;'"
                      v-bind:placeholder="'검색어를 입력하세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>

              <dd>
                <label>사용여부 </label>
                <ul class="filter_tab">
                  <kendo-buttongroup
                    ref="useYnButtonGroupRef"
                    @select="commonOnChangeEvent"
                    v-bind:style="{width: '100%', border: '0'}"
                    :index="0">
                    <kendo-buttongroup-button v-bind:style="'width: 34%;'"
                                              v-for="data in this.$store.state.codeRequestStore.search.button.useYn.data"
                                              v-bind:key="data.cdNameSpace"
                    >
                      {{data.cdNm}}
                    </kendo-buttongroup-button>
                  </kendo-buttongroup>
                </ul>

              </dd>
              <dd>
              <label>솔루션/구분</label>
              <ul>
                <kendo-multicolumncombobox
                  ref="searchSolCdRef"
                  id="searchSolCd"
                  :data-text-field="'solNm'"
                  :data-value-field="'value'"
                  :data-source="solutionDataArray"
                  @change="commonOnChangeEvent"
                  :filter="'contains'"
                  style="width:500px"
                  v-bind:placeholder="'솔루션을 선택하세요'"
                  >
                  <kendo-multicolumncombobox-column :field="'solNm'" :title="'솔루션'"></kendo-multicolumncombobox-column>
                  <kendo-multicolumncombobox-column :field="'wmGbnText'" :title="'구분'" :width="120"></kendo-multicolumncombobox-column>
                </kendo-multicolumncombobox>
              </ul>
              </dd>

            </li>
          </ul>
        </div>
        <div class="button_wrap_area">
          <ul>
            <li>
              <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
            </li>
            <li>
              <button class="large_btn" @click="cleanSearchDataEvent">초기화</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- //검색 영역 -->

    <section>
      <div class="content_list">
        <!-- Kendo 영역 -->
        <kendo-grid ref="menuListGridRef"
                    id="menuListGrid"
                    style="cursor: pointer"
                    :data-source="computedMenuListGridRows"
                    :navigatable="true"
                    :filterable="false"
                    :sortable="true"
                    :scrollable="true"
                    :pageable-always-visible="true"
                    :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="true"
                    :columns="menuListColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
                    :dataBound="onDataBoundForMenuListGrid"
                    v-on:change="onChangeMenuListGrid"
        >
        </kendo-grid>
        <!-- Kendo 영역 끝 -->
      </div>
    </section>
  </div>
</template>

<script>
  import $ from 'jquery'

  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersKendoGridUtil from '@/common/kendo.grid.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import EtnersDateTimeUtil from '@/common/etners.datetime.util'

  const platformDomain = ApiConfig.platformDomain

  export default {
    name    : 'AdminMenu',

    data () {
      const finalSolutionMap = []
      const solutionMap = EtnersCommonUtil.getAllSolutionMasterMapUsingVuex()
      const codeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()

      for(const key in solutionMap){
       const keyMap = solutionMap[key]
        for(const keyMapArray in keyMap){

          keyMap[keyMapArray].value = `${keyMap[keyMapArray].solCd}_${keyMap[keyMapArray].wmGbn}`
          keyMap[keyMapArray].wmGbnText = EtnersParseUtil.commonCodeToText(codeMap,`102_${keyMap[keyMapArray].wmGbn}`)

          finalSolutionMap.push(keyMap[keyMapArray])
        }

      }

      const kendoGridHeaderAttributes = {
        style: 'font-weight: bold;',
      }
      return {
        solutionDataArray:finalSolutionMap,
        menuAllDataMap: [],
        rowNumber          : 0,
        searchTextData     : [
          { cdNm: '메뉴명', cdNameSpace: 'menuNm' },
          { cdNm: '메뉴ID', cdNameSpace: 'menuMasterPK.menuId' },
        ],
        menuListColumns: [

          { field: 'rowNumber', title: 'No', width: '5%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'cvtWmGbn', title: '웹/모바일구분', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'solNm', title: '솔루션명', width: '30%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'menuId', title: '메뉴ID', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'superMenuNm', title: '상위메뉴명', width: '15%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'menuNm', title: '메뉴명', width: '15%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'menuDepth', title: '메뉴계층', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'frstRgstDt', title: '등록일', width: '15%', headerAttributes: kendoGridHeaderAttributes },
          {
            field   : 'useYn', title: '사용여부', width: '10%', headerAttributes: kendoGridHeaderAttributes,
            template: function (dataItem) {
              return `<input id="useYnSwitch_${dataItem.solCd}${dataItem.wmGbn}${dataItem.menuId}" class="useYnSwitchTemplate" style="width: 170px;" />`
            },
          },
          { field: 'wmGbn',hidden:true }
        ],
      }
    },
    created : function () {

    },
    mounted () {


    },
    updated : function () {
      // 크롬에서 css가 안먹는 현상 임시 수정.
      // 정확한 원인은 파악되지 않았지만 vuex에서 commit을 사용하면
      // k-maskedtextbox 클래스가 먹은 span 태그에 k-textbox 클래스가 추가되면서 css가 어그러지는 현상을 발견함.
      const removeKTextBoxClass = function (count) {
        let inputElements = document.getElementsByClassName('k-widget k-maskedtextbox k-textbox')

        if (inputElements.length > 0 || count > 0) {
          try {
            for (let i = 0; i < inputElements.length; i++) {
              let element = inputElements[i]

              element.classList.remove('k-textbox')
            }
          } catch (e) { }

          setTimeout(function () {
            count--

            removeKTextBoxClass(count)
          }, 20)
        }
      }

      removeKTextBoxClass(10)
    },
    computed: {
      computedMenuListGridRows: function () {
        const vm = this

        const menuListDataSource = new kendo.data.DataSource({
          name           : 'menuListDataSource',
          page           : 1,
          pageSize       : 10,
          serverPaging   : true,
          serverFiltering: true,
          serverSorting  : false,
          transport      : {
            read        : {
              url        : `${ApiConfig.platformDomain}/v1/ebmp/admin/menu/list.json`,
              type       : 'POST',
              dataType   : 'json',
              contentType: 'application/json',
              cache      : false,
            },
            parameterMap: function (options, operation) {

              if (operation === 'read') {

                let paramToKendoFilters = vm.currentPageFilterOption()
                let loginUserToken = sessionStorage.lutk
                let integrationCustomFilters = paramToKendoFilters

                let params = {
                  loginUserToken: loginUserToken,
                  skip          : options.skip,
                  take          : options.take,
                  page          : options.page,
                  pageSize      : options.pageSize,
                  filter        : integrationCustomFilters !== undefined ? integrationCustomFilters : undefined,
                  sort          : options.sort,
                  requestType   : 'PAGING', //PAGING or EXPORT
                }
                sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
                return kendo.stringify(params)
              }

              if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) }
              }
            },
          },
          schema         : {
            type : 'json',
            parse: function (response) {
              let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()
              let solutionCodeMap = EtnersCommonUtil.getAllSolutionMasterMapUsingVuex()
              let menuAllDataMap = EtnersCommonUtil.getAllMenuMasterMapUsingVuex()
              // 맵이 초기화되었는지 여부 확인
              const initCommonCodeMapFl = commonCodeMap !== undefined&&commonCodeMap !== null
              const initSolutionMapFl = solutionCodeMap !== undefined&&solutionCodeMap !== null
              const initMenuAllDataMapFl = menuAllDataMap !== undefined&&menuAllDataMap !== null

               if (initCommonCodeMapFl&&initSolutionMapFl&&initMenuAllDataMapFl) {
              let changeResultData = response.resultData
              let rowNumber = (vm.$refs.menuListGridRef.dataSource.page() - 1) *
                vm.$refs.menuListGridRef.dataSource.pageSize()

              for (let i = 0; i < changeResultData.length; i++) {
                let row = changeResultData[i]
                // row 번호 셋팅
                row.rowNumber  = ++rowNumber

                row.solNm = EtnersParseUtil.solutionToText(solutionCodeMap, row.solCd, row.wmGbn)

                row.superMenuNm =EtnersParseUtil.superMenuIdToText(menuAllDataMap, row.superMenuId, row.solCd, row.wmGbn)

                row.cvtWmGbn = EtnersParseUtil.codeToText(commonCodeMap, `102_${row.wmGbn}`)
              }
              response.resultData = changeResultData
              } else {
              // 만약 코드-텍스트 변환을 위한 맵이 초기화되지 않았다면, 다시 한 번 그리드를 읽어들이도록 처리
               setTimeout(function () {
                 vm.$refs.menuListGridRef.kendoWidget().dataSource.read()
               }, 300)
               }

              return response
            },
            total: function (response) {
              return response.total
            },
            data : function (response) {
              if (response.resultStatus.messageCode === '2000') {
                return response.resultData
              } else {
                kendo.alert('message: ' + response.resultStatus.messageText)

                return ''
              }
            },
          },

          error: function (e) {
            console.log('error event handler', e.errors[0])
          },
        })

        return menuListDataSource
      },
    },

    methods: {
      getMenuAllDataMap : function(){
        let menuMap = {}
        const param = {
          loginUserToken: sessionStorage.lutk ,
          skip: 0,
          take: 10,
          page: 1,
          pageSize: 10,
          requestType: "EXPORT"
        }

          ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/menu/list.json`,param)
            .then(function (response) {

              if(response.data.resultStatus.messageCode === '2000'){
                menuMap = response.data.resultData
              }
            })

        return menuMap
      },
      cleanSearchDataEvent          : function (ev) {
        const refs = this.$refs


        if (refs.searchSolCdRef !== undefined) {
          refs.searchSolCdRef.kendoWidget().value('')
        }

        if (refs.searchCdRef !== undefined) {
          refs.searchCdRef.kendoWidget().select(0)
        }
        if (refs.searchTextRef !== undefined) {
          refs.searchTextRef.kendoWidget().value('')
        }
        // 사용여부
        if (refs.useYnButtonGroupRef !== undefined) {
          refs.useYnButtonGroupRef.kendoWidget().select(0)
        }

        this.commonOnChangeEvent(ev)
      },
      currentPageFilterOption       : function () {
        let searchFilterOptions = []

        const refs = this.$refs

        if (refs.searchSolCdRef !== undefined) {
          let searchSolCd = refs.searchSolCdRef.kendoWidget().value()

          if (searchSolCd !== undefined && searchSolCd !== '' ) {
            const solArr = searchSolCd.split('_')
            if(solArr !== undefined&&solArr.length>1) {
              searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
                columnName: 'menuMasterPK.solCd',
                value: solArr[0]
              }))
              searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
                columnName: 'menuMasterPK.wmGbn',
                value: solArr[1]
              }))
            }
            }
        }


        // 상세검색(메뉴명, 메뉴Url)
        if (refs.searchTextRef !== undefined) {
          const searchCd = refs.searchCdRef.kendoWidget().value()
          const searchText = refs.searchTextRef.kendoWidget().value()
          if (searchCd !== undefined && searchCd !== '' && searchText !== undefined && searchText !== '') {
            searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: searchCd, value: searchText }))
          }
        }
        // 사용여부
        if (refs.useYnButtonGroupRef !== undefined) {
          const useYnButtonGroupCurrentObj = refs.useYnButtonGroupRef.kendoWidget().current()
          const useYnButtonGroupIndex = useYnButtonGroupCurrentObj.index()

          switch (useYnButtonGroupIndex) {
            case 0:
              break
            case 1:
              searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: 'useYn', value: 'Y' }))
              break
            case 2:
              searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: 'useYn', value: 'N' }))
          }
        }

        return searchFilterOptions.length === 0 ? undefined : searchFilterOptions
      },
      onDataBoundForMenuListGrid: function (evt) {

        let grid = evt.sender
        let items = evt.sender.items()
        const vm = this

          items.each(function () {
            let dataItem = grid.dataItem(this)
            let useYnSwitchTemplate = $('.useYnSwitchTemplate', this)
            let loginUserToken = sessionStorage.lutk

            let isCheckedFunc = function () {
              return dataItem.useYn === 'Y'
            }

            $(useYnSwitchTemplate).kendoSwitch({
              checked: isCheckedFunc(),
              messages: {
                checked: '',
                unchecked: '',
              },
              change: function (data) {
                const useYn = data.checked ? 'Y' : 'N'
                const param = {
                  loginUserToken: loginUserToken,
                  useYn: useYn,
                  solCd: dataItem.solCd,
                  wmGbn: dataItem.wmGbn,
                  menuId: dataItem.menuId
                }

                let processMessage = data.checked ? '사용함' : '사용안함'

                kendo.confirm(`메뉴 ${dataItem.menuNm}의 사용여부 값을 ${processMessage}으로 변경하시겠습니까?`).done(function () {

                  ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/menu/updateUseYn.json`, param).then(function (response) {

                    if (response.data === undefined || response.data.resultStatus === undefined) {
                      kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
                      return false
                    }

                    const resultStatus = response.data.resultStatus

                    if (resultStatus.messageCode !== '2000') {
                      kendo.alert(resultStatus.messageText)
                      return false
                    }
                    vm.commonOnChangeEvent()
                  })
                }).fail(function () {
                  //현재 이벤트가 발생한 row의 switch 인스턴스를 가져온다. 이 때 데이터 정의시 식별 가능한 값으로 html의 ID 속성값을 세팅해두었어야 한다.
                  const switchInstance = $(`#useYnSwitch_${dataItem.solCd}${dataItem.wmGbn}${dataItem.menuId}`).data('kendoSwitch')

                  //Confirm이 Cancel되었으므로 이벤트를 원래대로 돌리도록 처리
                  switchInstance.toggle()
                })
              },
            })
          })

      },
      onChangeMenuListGrid (ev) {
        if (ev.sender._lastCellIndex !== 8) {
          let selectedRow = ev.sender.select()
          let rowData = ev.sender.dataItem(selectedRow)

          this.$router.push({name:'AdminMenuDetail',params:{wmGbn:rowData.wmGbn,solCd:rowData.solCd,menuId:rowData.menuId}})
        }
      },

      registMenu () {
        this.$router.push({name:'AdminMenuSave'})
      },
      commonOnChangeEvent: function (e) {

        if (this.$refs.menuListGridRef !== undefined) {
          let menuListGridRef = this.$refs.menuListGridRef.kendoWidget()

          if (menuListGridRef !== undefined) {
            const dataSource = menuListGridRef.dataSource
            if (dataSource !== undefined) {

              // 상세에서 목록으로 돌아온 경우, 대상이 없이 호출됨으로 인해 그리드가 초기화되는 오류 수정위한 if문
              if (e !== undefined) {
                dataSource.fetch().then(function () {
                  dataSource.page(1)
                })
              }
            }
          }
        }

      },
    },

  }
</script>


<style scoped>
</style>
